import { useTranslation } from "react-i18next";
import { Modal } from "@App/Components/Modal";

/** FINN's public website — where the blocked user is sent (not this app's whitelabel home page). */
export const FINN_WEBSITE_URL = "https://www.finn.com/";

/**
 * FINN-specific hard block for the whitelabel home page. FINN drivers must start every booking
 * from their FINN account, so the home page is covered by a modal that cannot be dismissed:
 * no close button, and Escape / backdrop clicks are inert (`closeable={false}`). The only way
 * out is the link back to finn.com.
 */
export function HomeBlockerModal() {
  const { t } = useTranslation();

  return (
    <Modal
      open={true}
      closeable={false}
      showButton={false}
      width="max-w-3xl"
      title={t("blockingModal.title")}
    >
      <div>
        <p>{t("blockingModal.text")}</p>
        <div className="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
          <a
            href={FINN_WEBSITE_URL}
            className="bg-primary w-full md:w-80 px-8 py-2 mt-4 text-white rounded text-center font-serif font-bold cursor-pointer no-underline focus:outline-none"
          >
            {t("blockingModal.linkLabel")}
          </a>
        </div>
      </div>
    </Modal>
  );
}
